import * as types from "./types";
import {
  getTipologie,
  getFluids,
  getRefrigerants,
  getFluidsManagementList,
  getFluidsManagementExportList,
  saveFluids,
  getExportModel
} from "./services";

export async function getTipologieAction() {
  try {
    return await getTipologie();
  } catch (e) {
    console.log(e);
  }
}

export async function getFluidsAction({ commit }) {
  try {
    const { data } = await getFluids();
    commit(types.FLUID_LIST, data);
  } catch (e) {
    console.log(e);
  }
}

export async function getRefrigerantsAction({ commit }) {
  try {
    const { data } = await getRefrigerants();
    commit(types.REFRIGERANT_LIST, data);
  } catch (e) {
    console.log(e);
  }
}

export async function getFluidsManagementListAction({ commit }) {
  try {
    return (await getFluidsManagementList()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getFluidsManagementExportListAction({ commit }) {
  try {
    return (await getFluidsManagementExportList()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function saveFluidsAction({ commit }, payload) {
  try {
    return (await saveFluids(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelAction({ commit }) {
  try {
    return (await getExportModel()).data;
  } catch (e) {
    console.log(e);
  }
}
